import constants from '../constants.js';

const ModifiedOn = {
  displayName: 'Modified on',
  dataAt: 'ModifiedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ModifiedBy = {
  displayName: 'Modified by',
  dataAt: 'ModifiedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreatedOn = {
  displayName: 'Created on',
  dataAt: 'CreatedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreatedBy = {
  displayName: 'Created by',
  dataAt: 'CreatedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const Id = {
  displayName: 'Identifier',
  dataAt: 'Id',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CarrierSustainabilityRating = {
  displayName: 'Carrier Sustainability Rating',
  dataAt: 'CarrierSustainabilityRating',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const CarrierName = {
  displayName: 'Carrier Name',
  dataAt: 'CarrierName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const IATACarrierCode = {
  displayName: 'IATA Carrier Code',
  dataAt: 'IATACarrierCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const ICAOCarrierCode = {
  displayName: 'ICAO Carrier Code',
  dataAt: 'ICAOCarrierCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const SafScoresResource = {
  displayName: 'Saf Score',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [Id, CarrierSustainabilityRating, CarrierName, IATACarrierCode, ICAOCarrierCode, CreatedOn, CreatedBy, ModifiedOn, ModifiedBy],
  endpoint: 'SafScores',
  routeParamId: 'safScoresId',
  hideSave: true
};

const SafScoresList = {
    rootNode: true,
    displayName: 'Saf Scores',  
    endpoint: 'SafScores',
    iconClass: 'fa-cog',
    displayAs: constants.DISPLAY_AS.GRID,
    gridItem: SafScoresResource,
    routeWithId: true,
    gridCols:
      [
        {name: 'IATACarrierCode', key: 'IATACarrierCode'},
        {name: 'CarrierSustainabilityRating', key: 'CarrierSustainabilityRating'},
        {name: 'CarrierName', key: 'CarrierName'},
        {name: 'ICAOCarrierCode', key: 'ICAOCarrierCode'}
      ]
  };

  export default {
    ModifiedOn,
    ModifiedBy,
    CreatedOn,
    CreatedBy,
    Id,
    CarrierSustainabilityRating,
    CarrierName,
    IATACarrierCode,
    ICAOCarrierCode,
    SafScoresResource,
    SafScoresList
  }


// WEBPACK FOOTER //
// ./src/config/fields/safScores.js